<script>

    import * as echarts from "echarts";
    import Moment from 'moment'
    import { onMount } from "svelte";

    import GraphicsService from '../$services/graphics.service'
    import StatesMap from '../$methods/states.map'

    import DateYearNav from '../$components/date.year.nav.svelte'

    let dateStart = Moment().subtract(1, 'year').startOf('day').toDate()
    let dateEnd = Moment().endOf('day').toDate()

    $: periodLabel = dateStart && dateEnd
        ? `${Moment(dateStart).format('D MMM YYYY')} – ${Moment(dateEnd).format('D MMM YYYY')}`
        : ''

    const states = [
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Campeche",
        "Coahuila de Zaragoza",
        "Colima",
        "Chiapas",
        "Chihuahua",
        "Ciudad de México",
        "Durango",
        "Guanajuato",
        "Guerrero",
        "Hidalgo",
        "Jalisco",
        "México",
        "Michoacán de Ocampo",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "San Luis Potosí",
        "Sinaloa",
        "Sonora",
        "Tabasco",
        "Tamaulipas",
        "Tlaxcala",
        "Veracruz de Ignacio de la Llave",
        "Yucatán",
        "Zacatecas"
    ]

    let chartContainer;

    onMount(async () => {

        const geoMexico = await fetch('/mexico.geojson')
            .then(res => res.json());

        const response = await GraphicsService.getShipmentsStates({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        });

        console.log(response.data.map(item => item._id))

        const max = Math.max(...response.data.map(item => item.value))

        echarts.registerMap("mexico", geoMexico);

        const chart = echarts.init(chartContainer);

        chart.setOption({
            tooltip: {
                trigger: "item",
                formatter: (params) => {
                    const value = Number.isFinite(params.value) ? params.value : 0;
                    return `${params.name}: ${value}`;
                }
            },
            visualMap: {
                min: 0,
                max: max,
                left: "left",
                bottom: "10%",
                text: ["Alto", "Bajo"],
                calculable: true
            },
            series: [
                {
                    name: "Actividad",
                    type: "map",
                    map: "mexico",
                    nameProperty: "NOMGEO",
                    roam: true,
                    emphasis: {
                    label: {
                        show: true
                    }
                    },
                    data: response.data.map(item => {
                        return {
                            name: StatesMap.limpiarEstado(item.name),
                            value: item.value
                        }
                    })
                }
            ]
        });

        const resize = () => chart.resize();
        window.addEventListener("resize", resize);

        return () => {
            window.removeEventListener("resize", resize);
            chart.dispose();
        };
    });


</script>

<style>
    .map {
        width: 100%;
        height: 600px;
    }
    .graphic-card {
        background: #fff;
        border-radius: 28px;
        box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
        padding: 1.5rem;
        margin-bottom: 1.25rem;
        display: flex;
        flex-direction: column;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1.25rem;
        gap: 1rem;
        box-shadow: none;
    }

    .logo {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #1a1a1a;
        font-size: 1.15rem;
        flex-shrink: 0;
    }

    .meta {
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
        margin-bottom: 0.35rem;
    }

    .meta-name {
        font-weight: 700;
        color: #1a1a1a;
        font-size: 0.95rem;
    }

    .meta-date {
        color: #9e9e9e;
        font-size: 0.85rem;
    }

    .title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.2;
        margin: 0 0 1.25rem;
    }

    .body {
        padding: 16px;
        border-radius: 20px;
    }
</style>

<div class="graphic-card">
    <div class="card-header">
        <div class="logo">
            <i class="fas fa-shipping-fast"></i>
        </div>
        <DateYearNav bind:dateStart bind:dateEnd />
    </div>

    <div class="meta">
        <span class="meta-name">Envíos</span>
        {#if periodLabel}
            <span class="meta-date">{ periodLabel }</span>
        {/if}
    </div>

    <h3 class="title">Envíos por estado</h3>

    <div class="body">
        <div bind:this={chartContainer} class="map"></div>
    </div>
</div>
